function initColorOptionSwatchGroups(root) {
  root = root || document;
  const swatchGroups = root.querySelector('.swatch-groups');
  const swatchContainer = root.querySelector('.swatch-container');
  const swatchItems = root.querySelectorAll('.swatch-item');

  if (!swatchGroups || !swatchContainer || swatchItems.length === 0) return;

  // Names in the order defined by the finish_options_order metaobject
  let sortOrder = [];
  try {
    sortOrder = JSON.parse(swatchGroups.dataset.sortOrder || '[]');
  } catch (error) {
    console.error('Error parsing swatch group sort order:', error);
  }

  // Create array of unique variant group values
  const variantGroups = [...new Set(Array.from(swatchItems).map(item => item.dataset.variantGroup))];

  // Order groups to match sortOrder; unlisted groups fall to the end, in their original order
  variantGroups.sort((a, b) => {
    const indexA = sortOrder.indexOf(a);
    const indexB = sortOrder.indexOf(b);
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });

  // Clear the original swatch-grid
  swatchGroups.innerHTML = '';
  swatchContainer.innerHTML = '';

  // Create a group for each unique variant group
  variantGroups.forEach(function(groupValue) {
    // Create group container
    const groupDiv = document.createElement('div');
    groupDiv.className = 'swatch-group';

    // Create title
    const titleDiv = document.createElement('div');
    titleDiv.className = 'swatch-group-title';
    titleDiv.textContent = groupValue;

    // Create sub-container
    const subContainerDiv = document.createElement('div');
    subContainerDiv.className = 'swatch-grid';

    // Find and move matching swatch items
    const matchingItems = Array.from(swatchItems).filter(item => item.dataset.variantGroup === groupValue);
    matchingItems.forEach(function(item) {
      subContainerDiv.appendChild(item);
    });

    // Assemble the group
    groupDiv.appendChild(titleDiv);
    groupDiv.appendChild(subContainerDiv);

    // Add to container
    swatchGroups.appendChild(groupDiv);
  });
}

window.initColorOptionSwatchGroups = initColorOptionSwatchGroups;

document.addEventListener('DOMContentLoaded', function() {
  initColorOptionSwatchGroups(document);
});
